import React from "react";
import { ControlLabel, Button, Alert, FormControl } from "react-bootstrap";
import ajax from "./../lib/ajax.js";
import context from "./../lib/context.js";
import util from "../lib/util.js";
import { browserHistory } from "react-router";

export default class ChangePassword extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            newPassword: '',
            retypeNewPassword: '',
            userFullName: '',
            changePasswordLabel: '',
            resetPasswordLabel: '',
            newPasswordLabel: '',
            retypeNewPasswordLabel: '',
            submitLabel: '',
            pleaseEnterNewPasswordMessage: '',
            pleaseConfirmNewPasswordMessage: '',
            doNotMatchMessage: '',
            passwordNotAllowMessage: '',
            passwordRestrictionInvalidMessage: '',
            resetPasswordSuccessfulMessage: '',
            changePasswordSuccessfulMessage: '',
            loginLabel: '',
            cancelLabel: '',
            errors: [],
            successMessage: ''
        };

        this.newPasswordChange = this.newPasswordChange.bind(this);
        this.retypeNewPasswordChange = this.retypeNewPasswordChange.bind(this);
        this.submitClick = this.submitClick.bind(this);
        this.loadChangePasswordViewModel = this.loadChangePasswordViewModel.bind(this);
        this.loadResetPasswordViewModel = this.loadResetPasswordViewModel.bind(this);
        this.cancelClick = this.cancelClick.bind(this);
    }

    componentDidMount() {
        if (this.props.route.path == 'reset-password/:token') {
            this.loadResetPasswordViewModel();
        }
        else if (this.props.route.path == 'change-password') {
            this.loadChangePasswordViewModel();
        }
    }

    loadResetPasswordViewModel() {
        let self = this;

        context.message({
            show: true, 
            type: "loading", 
            message:"Loading. Please wait..."
        });

        ajax.vm().get(`reset-password/${this.props.routeParams.token}`)
            .then(function (res) {
                self.setState({
                    userFullName: res.data.userFullName,
                    changePasswordLabel: res.data.changePasswordLabel,
                    resetPasswordLabel: res.data.resetPasswordLabel,
                    newPasswordLabel: res.data.newPasswordLabel,
                    retypeNewPasswordLabel: res.data.retypeNewPasswordLabel,
                    submitLabel: res.data.submitLabel,
                    pleaseEnterNewPasswordMessage: res.data.pleaseEnterNewPasswordMessage,
                    pleaseConfirmNewPasswordMessage: res.data.pleaseConfirmNewPasswordMessage,
                    doNotMatchMessage: res.data.doNotMatchMessage,
                    passwordNotAllowMessage: res.data.passwordNotAllowMessage,
                    passwordRestrictionInvalidMessage: res.data.passwordRestrictionInvalidMessage,
                    resetPasswordSuccessfulMessage: res.data.resetPasswordSuccessfulMessage,
                    changePasswordSuccessfulMessage: res.data.changePasswordSuccessfulMessage,
                    loginLabel: res.data.loginLabel,
                    cancelLabel: res.data.cancelLabel,
                    homeLabel: res.data.homeLabel
                });

                context.message({ show: false });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });

                browserHistory.push(context.routeUrl('login'));
            });
    }

    loadChangePasswordViewModel() {
        let self = this;

        context.message({
            show: true, 
            type: "loading", 
            message:"Loading. Please wait..."
        });

        ajax.vm().get('change-password')
            .then(function (res) {
                self.setState({
                    userFullName: res.data.userFullName,
                    changePasswordLabel: res.data.changePasswordLabel,
                    newPasswordLabel: res.data.newPasswordLabel,
                    retypeNewPasswordLabel: res.data.retypeNewPasswordLabel,
                    submitLabel: res.data.submitLabel,
                    pleaseEnterNewPasswordMessage: res.data.pleaseEnterNewPasswordMessage,
                    pleaseConfirmNewPasswordMessage: res.data.pleaseConfirmNewPasswordMessage,
                    doNotMatchMessage: res.data.doNotMatchMessage,
                    defaultTempPassword: res.data.defaultTempPassword,
                    passwordNotAllowMessage: res.data.passwordNotAllowMessage,
                    passwordRestrictionInvalidMessage: res.data.passwordRestrictionInvalidMessage
                });

                // show default password message
                if (res.data.foundDefaultPasswordMessage != '') {
                    let msg = [];
                    msg.push(res.data.foundDefaultPasswordMessage);
                    self.setState({
                        errors: msg
                    });
                }

                context.message({ show: false });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    newPasswordChange(event) {
        let value = event.target.value.trim();
        this.setState({
            newPassword: value
        });
    }

    retypeNewPasswordChange(event) {
        let value = event.target.value.trim();
        this.setState({
            retypeNewPassword: value
        });
    }

    submitClick() {
        var messages = this.validate();
        this.setState({
            errors: messages,
            reportData: null
        });

        if (messages.length == 0) {
            this.submit();
        }
    }

    cancelClick() {
        if (this.props.route.path == 'reset-password/:token') {
            browserHistory.push(context.routeUrl('login'));
        }
        else {
            browserHistory.push(context.routeUrl('home'));
        }
    }

    submit() {
        let self = this;

        context.message({
            show: true, 
            type: "loading", 
            message:"Loading. Please wait..."
        });

        var params = { password: self.state.newPassword };
        var method = 'change-password';
        var successMessage = this.state.changePasswordSuccessfulMessage;

        if (this.props.route.path == 'reset-password/:token') {
            params = {
                token: this.props.routeParams.token,
                password: self.state.newPassword
            };

            method = 'reset-password';
            successMessage = this.state.resetPasswordSuccessfulMessage;
        }

        ajax.api().get(method, {
                params: params
            })
            .then(function (res) {
                self.setState({
                    successMessage: successMessage
                });
                
                context.message({ show: false });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    validate() {
        let msg = [];

        if (this.state.newPassword.length == 0) {
            msg.push(this.state.pleaseEnterNewPasswordMessage);
        }
        else if (this.state.retypeNewPassword.length == 0) {
            msg.push(this.state.pleaseConfirmNewPasswordMessage);
        }
        else if (this.state.newPassword != this.state.retypeNewPassword) {
            msg.push(this.state.doNotMatchMessage);
        }
        else if (util.isPasswordValid(this.state.newPassword) == false) {
            msg.push(this.state.passwordRestrictionInvalidMessage);
        }

        return msg;
    }

    render() {
        var rowStyle = {
            "padding-top": "10px"
        };

        var resetPassword = false;

        if (this.props.route.path == 'reset-password/:token') {
            resetPassword = true;
        }

        return (
            <div className="container">
                <div className="row">
                    <h2 className="text-center ap-title">{this.state.userFullName}</h2>
                </div>
                <br />
                <div className="row">
                    <h3 className="text-center" style={{fontStyle: "italic"}}>{resetPassword == true ? this.state.resetPasswordLabel : this.state.changePasswordLabel}</h3>
                </div>
                <br /><br />
                <div className="row text-center">
                    <div className="container-fluid">
                        <div className={"row " + (this.state.successMessage != '' ? 'ap-hidden' : '')}>
                            <div className="col-md-offset-3 col-lg-offset-3 col-md-6 col-lg-6">
                                <FormControl type="password" placeholder={this.state.newPasswordLabel}
                                    defaultValue={this.state.newPassword}
                                    onChange={this.newPasswordChange}
                                    maxLength="15"></FormControl>
                            </div>
                        </div>
                        <div className={"row " + (this.state.successMessage != '' ? 'ap-hidden' : '')}>
                            <div className="col-md-offset-3 col-lg-offset-3 col-md-6 col-lg-6">
                                <FormControl type="password" placeholder={this.state.retypeNewPasswordLabel}
                                    defaultValue={this.state.retypeNewPassword}
                                    onChange={this.retypeNewPasswordChange}
                                    maxLength="15"></FormControl>
                            </div>
                        </div>
                        <div className={"row " + (this.state.successMessage != '' ? 'ap-hidden' : '')}>
                            <div className="col-md-3 col-lg-3"></div>
                            <div className="col-md-3 col-lg-3">
                                <Button onClick={this.submitClick} className="btn-info ap-fullsize">{this.state.submitLabel}</Button>
                            </div>
                            <div className="col-md-3 col-lg-3">
                                <Button onClick={this.cancelClick} className="btn-info ap-fullsize">{this.state.cancelLabel}</Button>
                            </div>
                            <div className="col-md-3 col-lg-3"></div>
                        </div>
                        <div className={"row " + (this.state.errors.length > 0 ? "" : "ap-hidden")} style={rowStyle}>
                            <div className="col-md-offset-3 col-lg-offset-3 col-md-6 col-lg-6">
                                <Alert bsStyle="danger">
                                    <ul>
                                        {this.state.errors.map(m =>
                                            <li key={m}>{m}</li>)}
                                    </ul>
                                </Alert>
                            </div>
                        </div>
                        <div className={"row " + (this.state.successMessage == '' ? 'ap-hidden' : '')} style={rowStyle}>
                            <div className="col-md-offset-3 col-lg-offset-3 col-md-6 col-lg-6">
                                <Alert bsStyle="success">
                                        <ControlLabel>{this.state.successMessage}</ControlLabel>
                                </Alert>
                            </div>
                        </div>
                        <div className={"row " + (this.state.successMessage == '' ? 'ap-hidden' : '')}>
                            <div className="col-md-offset-3 col-lg-offset-3 col-md-6 col-lg-6">
                                <ControlLabel style={{fontSize: "20px"}}>&nbsp;</ControlLabel>
                                <Button onClick={this.cancelClick} className="btn-info ap-fullsize">{resetPassword == true ? this.state.loginLabel : this.state.homeLabel}</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}